<template>
	<div>
		<div class="uk-margin-small-bottom" style="margin-bottom: calc(10px + 0.5em) !important;">
			<nav class="uk-navbar-container" uk-navbar>
				<div class="uk-navbar-left">
					<h1 class="uk-navbar-item uk-logo">パスワード変更</h1>
				</div>
				<div class="uk-navbar-right">
					<div class="navbar-item uk-margin-right">
						<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="returnButton">戻る</button>
					</div>
				</div>
			</nav>
		</div>
		<div class="uk-container">
			<div class="uk-margin-bottom" style="margin-bottom: calc(20px + 0.5em) !important;" v-if="forcedReasonMessage">
				<p style="color: #000;">{{ forcedReasonMessage }}</p>
			</div>
			<div id="password_change_form" class="uk-form-horizontal">
				<div class="uk-margin" v-if="this.generalError">
					<p class="uk-alert-danger uk-padding-small">{{ this.generalErrorMessage }}</p>
				</div>
				<template v-if="!isForcedChange">
					<div class="uk-margin">
						<label class="uk-form-label" for="form_horizontal_staff_number">社員番号 (必須)</label>
						<div class="uk-form-controls">
							<input class="uk-input" id="form_horizontal_staff_number" name="staff_number" type="text" placeholder="社員番号を入力してください" required>
						</div>
						<div class="uk-form-controls">
							<p class="uk-alert-danger uk-padding-small uk-margin-top" v-if="this.staffNumberError">{{ this.staffNumberErrorMessage }}</p>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="form_horizontal_current_password">現在のパスワード (必須)</label>
						<div class="uk-form-controls uk-flex uk-flex-middle">
							<input class="uk-input uk-width-expand" id="form_horizontal_current_password" name="current_password" :type="showCurrentPassword ? 'text' : 'password'" placeholder="現在のパスワードを入力してください" required>
							<label class="uk-margin-small-left uk-text-nowrap">
								<input class="uk-checkbox" type="checkbox" v-model="showCurrentPassword"> 表示
							</label>
						</div>
						<div class="uk-form-controls">
							<p class="uk-alert-danger uk-padding-small uk-margin-top" v-if="this.currentPasswordError">{{ this.currentPasswordErrorMessage }}</p>
						</div>
					</div>
					<div class="uk-margin" style="height: 0.5em;"></div>
				</template>
				<div class="uk-margin">
					<p class="uk-text-danger">＜注意喚起＞ 推測されやすいパスワードは避けてください。（英数字4桁以上）</p>
					<label class="uk-form-label" for="form_horizontal_new_password">新しいパスワード (必須)</label>
					<div class="uk-form-controls uk-flex uk-flex-middle">
						<input class="uk-input uk-width-expand" id="form_horizontal_new_password" name="new_password" :type="showNewPassword ? 'text' : 'password'" placeholder="新しいパスワードを入力してください" required maxlength="16">
						<label class="uk-margin-small-left uk-text-nowrap">
							<input class="uk-checkbox" type="checkbox" v-model="showNewPassword"> 表示
						</label>
					</div>
					<div class="uk-form-controls">
						<p class="uk-alert-danger uk-padding-small uk-margin-top" v-if="this.newPasswordError">{{ this.newPasswordErrorMessage }}</p>
					</div>
				</div>
				<div class="uk-margin">
					<label class="uk-form-label" for="form_horizontal_new_password_confirmation">新しいパスワード確認 (必須)</label>
					<div class="uk-form-controls uk-flex uk-flex-middle">
						<input class="uk-input uk-width-expand" id="form_horizontal_new_password_confirmation" name="new_password_confirmation" :type="showNewPasswordConfirmation ? 'text' : 'password'" placeholder="新しいパスワードを再度入力してください" required maxlength="16">
						<label class="uk-margin-small-left uk-text-nowrap">
							<input class="uk-checkbox" type="checkbox" v-model="showNewPasswordConfirmation"> 表示
						</label>
					</div>
					<div class="uk-form-controls">
						<p class="uk-alert-danger uk-padding-small uk-margin-top" v-if="this.newPasswordConfirmationError">{{ this.newPasswordConfirmationErrorMessage }}</p>
					</div>
				</div>
				<div class="uk-margin">
					<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" @click="onClickSubmit">変更</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import StaffAuth from '@/api/StaffAuth'

	export default {
		name: 'StaffPasswordChangePage',
		data () {
			return {
				isForcedChange: false,
				forcedStaffNumber: '',
				forcedCurrentPassword: '',
				forcedReason: '',
				generalError: false,
				generalErrorMessage: '',
				staffNumberError: false,
				staffNumberErrorMessage: '',
				currentPasswordError: false,
				currentPasswordErrorMessage: '',
				newPasswordError: false,
				newPasswordErrorMessage: '',
				newPasswordConfirmationError: false,
				newPasswordConfirmationErrorMessage: '',
				showCurrentPassword: false,
				showNewPassword: false,
				showNewPasswordConfirmation: false
			}
		},
		created () {
			let staffNumber = this.$route.params.staffNumber
			let currentPassword = this.$route.params.currentPassword
			let reason = this.$route.params.reason

			if (staffNumber && currentPassword) {
				sessionStorage.setItem('staff_forced_password_change', JSON.stringify({
					staffNumber: staffNumber,
					currentPassword: currentPassword,
					reason: reason
				}))
			} else {
				let cache = sessionStorage.getItem('staff_forced_password_change')
				if (cache) {
					let data = JSON.parse(cache)
					staffNumber = data.staffNumber
					currentPassword = data.currentPassword
					reason = data.reason
				}
			}

			if (staffNumber && currentPassword) {
				this.isForcedChange = true
				this.forcedStaffNumber = staffNumber
				this.forcedCurrentPassword = currentPassword
				this.forcedReason = reason
			}
		},
		computed: {
			forcedReasonMessage () {
				if (this.forcedReason === 'ADMIN_SETTING') {
					return '初期パスワードのため、パスワードを変更してください。'
				}
				if (this.forcedReason === 'EXPIRED') {
					return 'パスワード有効期限を超過しました。変更してください。'
				}
				return ''
			}
		},
		methods: {
			/**
			 * 戻るボタン押下時
			 */
			returnButton () {
				sessionStorage.removeItem('staff_forced_password_change')
				// 履歴を置き換え、ブラウザの戻るでパスワード変更画面に戻らないようにする
				this.$router.replace('/staff/login')
			},
			onClickSubmit () {
				let self = this

				self.generalError = false
				self.generalErrorMessage = ''
				self.staffNumberError = false
				self.staffNumberErrorMessage = ''
				self.currentPasswordError = false
				self.currentPasswordErrorMessage = ''
				self.newPasswordError = false
				self.newPasswordErrorMessage = ''
				self.newPasswordConfirmationError = false
				self.newPasswordConfirmationErrorMessage = ''

				let staff_number = self.isForcedChange ? self.forcedStaffNumber : $('[name="staff_number"]').val()
				let current_password = self.isForcedChange ? self.forcedCurrentPassword : $('[name="current_password"]').val()
				let new_password = $('[name="new_password"]').val()
				let new_password_confirmation = $('[name="new_password_confirmation"]').val()

				if (!self.isForcedChange && staff_number === '') {
					self.staffNumberError = true
					self.staffNumberErrorMessage = '社員番号を入力してください。'
				}
				if (!self.isForcedChange && current_password === '') {
					self.currentPasswordError = true
					self.currentPasswordErrorMessage = '現在のパスワードを入力してください。'
				}
				if (new_password === '') {
					self.newPasswordError = true
					self.newPasswordErrorMessage = '新しいパスワードを入力してください。'
				}
				if (new_password_confirmation === '') {
					self.newPasswordConfirmationError = true
					self.newPasswordConfirmationErrorMessage = '新しいパスワード確認を入力してください。'
				}

				if (self.staffNumberError || self.currentPasswordError || self.newPasswordError || self.newPasswordConfirmationError) {
					return
				}

				if (!/^[A-Za-z0-9]{4,}$/.test(new_password)) {
					self.newPasswordError = true
					self.newPasswordErrorMessage = '新しいパスワードは4桁以上の半角英数を入力してください。'
					return
				}

				if (new_password !== new_password_confirmation) {
					self.newPasswordConfirmationError = true
					self.newPasswordConfirmationErrorMessage = '新しいパスワードと一致しません。'
					return
				}

				let params = new URLSearchParams()
				params.append('staff_number', staff_number)
				params.append('current_password', current_password)
				params.append('new_password', new_password)

				StaffAuth.changePassword(params).then(function (response) {
					let data = response.data

					if (data.data == false) { // 失敗
						if (data.message === 'ADMIN STAFF') {
							if (self.isForcedChange) {
								self.generalError = true
								self.generalErrorMessage = '管理者IDはパスワードを変更できません。'
							} else {
								self.staffNumberError = true
								self.staffNumberErrorMessage = '管理者IDはパスワードを変更できません。'
							}
						} else if (data.message === 'SAME PASSWORD') {
							self.newPasswordError = true
							self.newPasswordErrorMessage = '現在のパスワードと同じパスワードは設定できません。'
						} else if (self.isForcedChange) {
							self.generalError = true
							self.generalErrorMessage = '社員番号またはパスワードが間違っています。'
						} else {
							self.staffNumberError = true
							self.staffNumberErrorMessage = '社員番号またはパスワードが間違っています。'
							self.currentPasswordError = true
							self.currentPasswordErrorMessage = '社員番号またはパスワードが間違っています。'
						}
					} else { // 成功
						sessionStorage.removeItem('staff_forced_password_change')
						if (self.isForcedChange) {
							StaffAuth.current().then(function (response) {
								let current_staff = response.data.data

								alert('パスワードを変更しました。')
								document.title = '予約管理ツール【スタッフ】'
								self.$router.replace('/reservation_list/' + current_staff.shop_id)
							})
						} else {
							alert('パスワードを変更しました。')
							self.$router.replace('/staff/login')
						}
					}
				})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/auth/StaffPasswordChangePage.vue